import React from 'react';

export const ExcellentRatingIcon = ({ borderClass }: { borderClass?: string }) => {
    return (
        <span className={borderClass}>
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" fill="none">
                <path
                    d="M17.5 33c8.837 0 16-7.163 16-16s-7.163-16-16-16-16 7.163-16 16 7.163 16 16 16Z"
                    fill="#00D682"
                />
                <path
                    d="M23.1 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0ZM13.5 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0ZM17.5 25.8c4 0 7.2-2.933 7.2-5.6H10.3c0 2.667 3.2 5.6 7.2 5.6Z"
                    fill="#00D682"
                />
                <path
                    d="M22.3 12.2h.016m-9.616 0h.016M33.5 17c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16Zm-10.4-4.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm-9.6 0a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm4 13.6c4 0 7.2-2.933 7.2-5.6H10.3c0 2.667 3.2 5.6 7.2 5.6Z"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};
